module.exports = __webpack_public_path__ + "media/stylesheets/flag-icon-css/flags/1x1/fr-c88df3297cffe49852ae43ae5d2dcdd4.svg";